import { render, staticRenderFns } from "./HintsAndKeypoints.vue?vue&type=template&id=7a157406"
import script from "./HintsAndKeypoints.vue?vue&type=script&lang=js"
export * from "./HintsAndKeypoints.vue?vue&type=script&lang=js"
import style0 from "./HintsAndKeypoints.vue?vue&type=style&index=0&id=7a157406&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a157406')) {
      api.createRecord('7a157406', component.options)
    } else {
      api.reload('7a157406', component.options)
    }
    module.hot.accept("./HintsAndKeypoints.vue?vue&type=template&id=7a157406", function () {
      api.rerender('7a157406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HintsAndKeypoints/Modal/HintsAndKeypoints.vue"
export default component.exports